import {
  useWSSnackbar,
  WSModal,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import { useMutationUpdateWorkLog } from "../../../../query/workLog/mutations/useMutationUpdateWorkLog";

type Props = {
  workLogId: string;
  onClose: (success: boolean) => void;
};

export const ModalRemoveWorkLogNotes: React.FC<Props> = ({
  workLogId,
  onClose
}) => {
  const { openSnackbar } = useWSSnackbar();
  const [updateWorkLog, updateWorkLogMeta] = useMutationUpdateWorkLog();

  const handleRemove = async () => {
    await updateWorkLog(
      { workLogId, request: { notes: "" } },
      {
        onSuccess: () => {
          openSnackbar({
            icon: { name: "check" },
            message: "Notes removed"
          });
          onClose(true);
        },
        onError: () => {
          openSnackbar({
            message: "Failed to remove notes",
            type: "error"
          });
        }
      }
    );
  };

  return (
    <WSModal
      title="Remove notes"
      onClose={() => onClose(false)}
      size="S"
      actions={{
        alignment: "fill",
        buttons: [
          {
            kind: "Tertiary",
            label: "Cancel",
            type: "button",
            onClick: () => onClose(false)
          },
          {
            kind: "Secondary",
            label: "Remove notes",
            onClick: handleRemove,
            loading: updateWorkLogMeta.isLoading,
            destructive: true
          }
        ]
      }}
    >
      <WSText.ParagraphSm>
        Are you sure you want to remove notes?
      </WSText.ParagraphSm>
    </WSModal>
  );
};
